/* eslint-disable no-shadow */
export enum UserRole {
  /** 医師 */
  Doctor = 'doctor',

  /** 看護師 */
  Nurse = 'nurse',

  /** 管理栄養士 */
  Dietitian = 'registered_dietitian',

  /** 臨床心理士 */
  ClinicalPsychologist = 'clinical_psychologist',

  Concierge = 'concierge',

  Patient = 'patient',

  Guest = 'guest',
}

export const roleLabelMap = {
  [UserRole.Doctor]: '医師',
  [UserRole.Nurse]: '看護師',
  [UserRole.Concierge]: 'コンシェルジュ',
  [UserRole.Dietitian]: '管理栄養士',
  [UserRole.ClinicalPsychologist]: '臨床心理士',
  [UserRole.Patient]: '患者',
};

export enum UserGender {
  NotSet = '未設定',
  Male = '男性',
  Female = '女性',
  Other = 'その他',
}
/* eslint-enable */
